var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "layoutTop" }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-10 offset-md-1 " }, [
            _c("div", { staticClass: "row form-group ml-0" }, [
              _c("div", { staticClass: "row rowSearchBar" }, [
                _c(
                  "div",
                  { staticClass: "showSmallScreenOnly" },
                  [
                    _c(
                      "f7-fab",
                      {
                        staticClass:
                          "leftfav2 button-fab bottomButton floatingButtonToolbarBlank milkyBlockBlack",
                        on: { click: _vm.refreshList },
                      },
                      [_c("f7-icon", { attrs: { f7: "refresh" } })],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "firstButtonMarginLeft showLargeScreenOnly" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "new-button-white milkyBlockBlack",
                        on: { click: _vm.refreshList },
                      },
                      [
                        _c("f7-icon", { attrs: { f7: "refresh" } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "fab-label" }, [
                          _vm._v(_vm._s(_vm.$t("common.rfrsh"))),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "panel21 panel-default float-none" }, [
              _c("div", { staticClass: "form-group row" }, [
                _c("label", { staticClass: "col-5 col-sm-2 col-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("rights.rights_profile"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-7 col-sm-10" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedConfig,
                          expression: "selectedConfig",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { id: "sel4", readonly: "" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedConfig = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c("option", { domProps: { value: _vm.defaultConfig } }, [
                        _vm._v(_vm._s(_vm.$t("rights.create_profile"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.configList, function (config) {
                        return _c(
                          "option",
                          {
                            key: config.idProfile,
                            domProps: { value: config },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(config.libelleProfile) +
                                "\n                  "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.selectedConfig.idProfile !== -1
                ? _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-4 blackBottomButton",
                        on: { click: _vm.deleteProfile },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "button-round attachmentButton buttonAccordionForm longword-word button",
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("rights.delete_profile")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("rights-list", {
                    key: _vm.selectedConfig.idProfile,
                    attrs: {
                      userID: _vm.selectedConfig.idProfile,
                      userRights: _vm.selectedConfig.rights,
                      isNewProfile: _vm.selectedConfig.idProfile === -1,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-3 offset-md-9" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "milkyBlockBlack button-action firstButtonMarginTop",
                    attrs: { round: "" },
                    on: { click: _vm.saveProfile },
                  },
                  [
                    _c("i", { staticClass: "icon fa fa-save" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "toolbarPageBottomBlank" }),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }